import { useEffect, useState } from "react"
import { svgs } from "../../assets/svgs"
import { useGlobalState } from "../../hooks/useGlobalState"
import { ACTIONS } from "../../state"
import { getData } from "../../utils/apiCalls"


export const Payment = () => {
   const { price, paymentInfo, dispatch, processOrder, orderResponse, currStageIdx, invalidInputMsg } = useGlobalState()
   const [isChecked, setIsChecked] = useState(false)
   const [billingFields, setBillingFields] = useState({})

   const currentYear = new Date().getFullYear()
   const next20Years = Array.from({ length: 20 }, (_, index) => currentYear + index)
   const months = Array.from({ length: 12 }, (_, index) => (index + 1).toString().padStart(2, '0'))


   useEffect(() => {
      dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: true })
      getData('https://youngstartup.io/api/cwebsite/get_form_fields?form_type=form&form_id=53&table=cwebsite')
         .then(res => setBillingFields(res))
         .finally(() => dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: false }))
   }, [])

   useEffect(() => {
      if (orderResponse.success) {
         dispatch({ type: ACTIONS.SET, entity: 'currStageIdx', payload: currStageIdx + 1 })
      }
   }, [orderResponse])

   const handelChecked = (e) => {
      setIsChecked(e.target.checked)
      dispatch({ type: ACTIONS.SET, entity: 'invalidInputMsg', payload: [] })
   }

   const handelSubmit = (e) => {
      e.preventDefault()
      if (price.total > 0 && billingValidations()) {
         return
      }
      dispatch({ type: ACTIONS.SET, entity: 'processOrder', payload: !processOrder })
   }

   const handelChange = (e) => {
      dispatch({ type: ACTIONS.SET, entity: 'invalidInputMsg', payload: [] })
      dispatch({ type: ACTIONS.SET, entity: 'paymentInfo', payload: { ...paymentInfo, [e.target.name]: e.target.value } })
   }

   const billingValidations = () => {
      const msg = []
      billingFields.fields.map(field => {
         const val = paymentInfo[field.internal_name]
         if (!field.validations?.required) return
         if (!val) {
            msg.push({ field: field.internal_name, msg: `invalid ${field.label}` })
            return
         }
         if (field.validations?.min) {
            if (val.length < field.validations.min) {
               msg.push({ field: field.internal_name, msg: `invalid ${field.label}` })
               return
            }
         }
         if (field.validations?.max) {
            if (val.length > field.validations.max) {
               msg.push({ field: field.internal_name, msg: `invalid ${field.label}` })
               return
            }
         }
         if (field.validations?.pattern) {
            const pattern = new RegExp(field.validations.pattern)
            if (!pattern.test(val)) {
               msg.push({ field: field.internal_name, msg: `invalid ${field.label}` })
               return
            }
         }
      })
      dispatch({ type: ACTIONS.SET, entity: 'invalidInputMsg', payload: msg })
      return msg.length
   }

   return (
      <div className="payment">
         <section className="form">
            <h1>{price.total > 0 ? 'Payment' : 'No Payment Required'}</h1>
            {price.total > 0 && <form onSubmit={handelSubmit}>
               <section className="card-info">
                  <div className='input'>
                     <input onChange={handelChange} type="text" placeholder="card number" maxLength={36} name="card_number" id="card_number" value={paymentInfo.card_number} autocomplete="off" />
                     <label htmlFor="card_number">card number</label>
                     <div className='error'>
                        {invalidInputMsg?.find(i => i.field === 'card_number')?.msg}
                     </div>
                  </div>
                  <div>
                     <div className='input exp'>
                        <select onChange={handelChange} name="month" id="month" defaultValue='' >
                           <option value="" disabled>--</option>
                           {months.map((month, idx) =>
                              <option key={idx} value={month}>{month}</option>
                           )}
                        </select>
                        <span>&nbsp;/&nbsp;</span>
                        <select onChange={handelChange} name="year" id="year" defaultValue='' >
                           <option value="" disabled>-----</option>
                           {next20Years.map((year, idx) =>
                              <option key={idx} value={year}>{year}</option>
                           )}
                        </select>
                        <label>exp</label>
                        <div className='error'>
                           {invalidInputMsg?.find(i => ['year', 'month'].includes(i.field))?.msg}
                        </div>
                     </div>
                     <div className='input'>
                        <input onChange={handelChange} type="text" placeholder="cvv" name="cvv" id="cvv" value={paymentInfo.cvv} autocomplete="off" />
                        <label htmlFor="cvv">cvv</label>
                        <div className='error'>
                           {invalidInputMsg?.find(i => i.field === 'cvv')?.msg}
                        </div>
                     </div>
                  </div>
               </section>
               <span>
                  <div>{svgs.securePayment} 100% Secure Payment</div>
                  <div>{svgs.visa} {svgs.mastercard} {svgs.discover} {svgs.amex}</div>
               </span>
               <h1>Billing Information</h1>
               <section>
                  {billingFields?.fields?.filter(f => billingFields.layout.groups.find(x => x.id === 2).fields.includes(f.id)).map((input, inputIdx) =>
                     <div key={inputIdx} className='input'>
                        {
                           input.element_type === 'input' &&
                           <input
                              placeholder={`enter your ${input.label}`}
                              minLength={input?.validations?.min}
                              maxLength={input?.validations?.max}
                              id={input.label}
                              type={input.type}
                              required={input?.validations?.required}
                              name={input.internal_name}
                              value={paymentInfo[input.internal_name]}
                              onChange={handelChange}
                              pattern={input.validations.pattern}
                           />
                        }
                        {
                           input.element_type === 'select' &&
                           <select
                              name={input.internal_name}
                              id={input.label}
                              onChange={handelChange}
                              defaultValue={paymentInfo[input.internal_name] || ''}
                           >
                              <option value="" disabled>Select an option</option>
                              {
                                 input.options.map((option, optionIdx) =>
                                    <option
                                       key={option.id}
                                       value={option.option_value}
                                    >{option.option_display}</option>
                                 )
                              }
                           </select>
                        }
                        <label htmlFor={input.id}>{input.label}</label>
                        <div className='error'>
                           {invalidInputMsg?.find(i => i.field === input.internal_name)?.msg}
                        </div>
                     </div>
                  )}
               </section>
               <h1>Cancellation Policy</h1>
               <p>We will refund 25% of the fee with written cancellations received no later than two weeks prior to event date. After that date, no refunds will be issued</p>
               <p>We do not share or sell your contact information to anyone, ever.</p>
               <div className='checkbox' >
                  <input onChange={handelChecked} required type="checkbox" name="checkbox" id="checkbox" checked={isChecked} />
                  <h2>I agree</h2>
               </div>
               <button type='submit' className='btn'>Pay Now</button>
               {orderResponse.message &&
                  <div>
                     <h4>{orderResponse.message} Please check all fields and try again.</h4>
                     <ul>{orderResponse.errors?.map((i, idx) =>
                        <li key={idx}>{i.errorText}</li>)}
                     </ul>
                  </div>
               }
            </form>}
            {price.total === 0 && <button onClick={handelSubmit} className='btn'>Register Now</button>}
         </section>
      </div>
   )
}
